import * as types from './logSourcesActionTypes';
import _ from 'lodash';

export default (state = [], action) => {
    switch(action.type) {
        case types.LOAD_LOG_SOURCES_SUCCESS:
        {
            const groups = _.groupBy(action.logSources, source => source.category);
            return Object.keys(groups);
        }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/log-sources/logSourceFiltersReducer.js